import React from "react";
import { ClipboardListIcon, StethoscopeIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { assessmentFactors, insideHighlights } from "../data/page";
import { PRICE } from "../data/offer";
export function IntroSection() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-234" data-mp="3k7mwcw5hpbb3">
      <div className="mx-auto max-w-5xl" data-id="element-235" data-mp="3p5of1fz078m1">
        <SectionHeading title="A more structured approach to diabetic foot assessment" subtitle="A practical educational reference for healthcare professionals who want to organize their assessment process with greater clarity." data-id="element-236" data-mp="3p4wur1auwxb2" />

        <div className="mx-auto mt-10 max-w-3xl space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-237" data-mp="6rfjhwix6ebu">
          <p data-id="element-238" data-mp="br1v61j3nmij">
            When you're evaluating a patient with diabetes, several important considerations may need your attention:
          </p>
          <ul className="flex flex-wrap justify-center gap-2" aria-label="Assessment considerations" data-id="element-239" data-mp="gqo6g5fdasop">
            {assessmentFactors.map(f => <li key={f} className="rounded-full bg-navy-900 px-4 py-2 text-sm font-semibold text-white" data-id="element-240" data-mp="g2pvxcrb4kkh">
                {f}
              </li>)}
          </ul>
          <p data-id="element-241" data-mp="b5pniv6zj5q7">
            Keeping track of these elements while navigating disconnected references can make the assessment process
            unnecessarily difficult.
          </p>
          <p data-id="element-242" data-mp="13rslr7w3hjq2">
            That's why I organized <strong className="text-ink" data-id="element-243" data-mp="yt7g2sy2q7u8">DIABETIC FOOT ASSESSMENT BLUEPRINT™</strong> into six
            focused volumes and five complementary resources. My goal is to give you one organized place to review key
            concepts, practice clinical reasoning, and structure your documentation.
          </p>
        </div>

        <h3 className="mt-14 text-center font-display text-2xl font-bold uppercase text-ink sm:text-3xl" data-id="element-244" data-mp="1mj1tbbmb1yf0">
          Inside the blueprint, you'll find:
        </h3>
        <ul className="mx-auto mt-8 grid max-w-4xl gap-x-10 gap-y-6 sm:grid-cols-2" data-id="element-245" data-mp="1hq8o6mmxco2e">
          {insideHighlights.map(h => <li key={h.title} className="flex gap-4" data-id="element-246" data-mp="3gzjpxd2vrody">
              <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-accent-soft font-display text-4xl font-bold text-navy-700" data-id="element-247" data-mp="3h136z5wd23gs">
                {h.lead === "icon-checklist" ? <ClipboardListIcon className="h-8 w-8" aria-hidden="true" data-id="element-248" data-mp="376uj4vi9yyoy" /> : h.lead === "icon-cases" ? <StethoscopeIcon className="h-8 w-8" aria-hidden="true" data-id="element-249" data-mp="2y920pih9baxc" /> : h.lead}
              </span>
              <div data-id="element-250" data-mp="2jdco2axyoa5a">
                <p className="text-lg font-bold text-ink" data-id="element-251" data-mp="2oacvap6jrixz">{h.title}</p>
                <p className="mt-1 text-base text-ink-soft" data-id="element-252" data-mp="2oal6mcn0ug72">{h.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-253" data-mp="mizt47vyrp5m">
          <CtaButton label={`Get your blueprint — $${PRICE}`} microcopy="Digital educational resource. It does not replace professional training, current clinical guidelines, or patient-specific clinical judgment." data-id="element-254" data-mp="mhwzhs79b8m0" />
        </div>
      </div>
    </section>;
}